<script lang="ts" setup>
/* App Info Panel Component
 *
 * This component displays detailed information about the currently selected app
 * including its name, description, and icon. It helps users distinguish between
 * similarly-named apps.
 */

const props = defineProps<{
    name: string;
    description: string;
    icon: string;
}>();
</script>

<template>
    <div class="lan:flex lan:flex-row lan:items-start lan:gap-3 lan:p-3 lan:mx-[15px] lan:mb-2.5 lan:bg-gray-50 lan:border lan:border-gray-200 lan:rounded-md">
        <img :src="props.icon" class="lan:w-10 lan:h-10 lan:rounded lan:shrink-0" />
        <div class="lan:flex lan:flex-col lan:gap-1 lan:min-w-0">
            <div class="lan:font-semibold lan:text-gray-900 lan:text-sm lan:truncate">
                {{ props.name }}
            </div>
            <div class="lan:text-xs lan:text-gray-500 lan:line-clamp-2">
                {{ props.description }}
            </div>
        </div>
    </div>
</template>
